import { Component, OnInit } from '@angular/core';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { shipmentEditorRedo, shipmentEditorUndo } from '../../../store/shipment-editor/shipment-editor.actions';
import { combineLatest, Observable } from 'rxjs';
import {
    selectShipmentEditable,
    selectShipmentEditorRedoAvailable,
    selectShipmentEditorUndoAvailable,
    selectShipmentEditorValid
} from '../../../store/shipment-editor/shipment-editor.state';
import { map, withLatestFrom } from 'rxjs/operators';
import { Router } from '@angular/router';
import { selectQuotingEditorActive } from '../../../store/quote-progress/quote-progress.state';
import { IconComponent } from '../../shared/icon/icon.component';
import { MatIconButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-shipment-undo-redo',
    templateUrl: './shipment-undo-redo.component.html',
    styleUrls: ['./shipment-undo-redo.component.scss'],
    imports: [MatIconButton, IconComponent, AsyncPipe]
})
export class ShipmentUndoRedoComponent implements OnInit {

    constructor(private store: Store<AppState>) {
    }

    undoUnavailable$: Observable<boolean>;
    redoUnavailable$: Observable<boolean>;
    canDisplay$: Observable<boolean>;

    ngOnInit(): void {
        this.undoUnavailable$ = this.store.select(selectShipmentEditorUndoAvailable).pipe(map((available) => !available));
        this.redoUnavailable$ = this.store.select(selectShipmentEditorRedoAvailable).pipe(map((available) => !available));
        this.canDisplay$ = combineLatest([
            this.store.select(selectShipmentEditorValid),
            this.store.select(selectQuotingEditorActive),
            this.store.select(selectShipmentEditable)
        ]).pipe(
            map(([ valid, quoting, editable ]) => valid && !quoting && editable)
        );
    }

    undo(): void {
        this.store.dispatch(shipmentEditorUndo());
    }

    redo(): void {
        this.store.dispatch(shipmentEditorRedo());
    }
}
